import type {
  DefaultError,
  QueryClient,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useSession } from './useSession';

/**
 * useQuery wrapper which is enabled only if the user is logged in.
 */
export const useAuthedQuery = <
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
  queryClient?: QueryClient
): UseQueryResult<TData, TError> => {
  const { isLoggedIn } = useSession();

  const finalOptions: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey> =
    {
      ...options,
      enabled: (options.enabled ?? true) && !!isLoggedIn,
    };

  return useQuery(finalOptions, queryClient);
};
